// TODO: Move this code to a Gatsby plugin
import { INDUSTRY_CHOICES } from "./ng-components/Filter/IndustryFilter";

const CATEGORIES = [
    "inspo",
    "hash-post",
    "brand-stories",
    "eco-alliance",
    "noissue-101",
    "biz-advice",
];

function getClassifiers(tags, specialTags) {
    return tags
        .filter(({ slug }) => specialTags.map(({ key }) => key).includes(slug))
        .map(({ slug }) => slug);
}

export function massageGhostPostsData(postsData, { availableSeries }, products) {
    const productTags = []
    products.forEach((item) => {
        if (item.wildSectionTagSlug && item.displayName) {
            productTags.push({
                "key": item.wildSectionTagSlug.toLowerCase().replace('#', 'hash-'),
                "label": item.displayName,
            });
        }
    })
    const { edges: posts } = postsData;
    return posts.map(
        ({
            node: {
                tags,
                feature_image,
                primary_author,
                published_at,
                ...post
            },
        }) => {
            const { slug: postSlug, title } = post;
            const { profile_image: authorImage, ...author } = primary_author;
            const products = getClassifiers(tags, productTags);
            const industries = getClassifiers(tags, INDUSTRY_CHOICES);

            const seriesSlugs = availableSeries.map(({ key }) => key);
            // Only one series allowed per post
            const series = tags.find(({ slug }) => seriesSlugs.includes(slug));

            return {
                ...post,
                publishedDate: published_at,
                link: `/${postSlug}`,
                heroImage: {
                    src: feature_image,
                    alt: title,
                },
                author: {
                    ...author,
                    image: {
                        src: authorImage,
                        alt: author.name,
                    },
                    link: `/author/${author.slug}`,
                },
                // We're using tags to classify posts
                products,
                industries,
                series,
                tags: tags
                    .filter(({ slug }) => {
                        return ![]
                            .concat(
                                CATEGORIES,
                                products,
                                industries,
                                series ? series.slug : []
                            )
                            .includes(slug);
                    })
                    .map(({ name, slug }) => ({
                        slug,
                        label: name,
                        link: `/tag/${slug}`,
                    })),
            };
        }
    );
}

export function massageGhostVideosData(videosData) {
    const { nodes: videos } = videosData;
    return videos.map(massageGhostVideoData);
}

export function massageGhostVideoData({
    excerpt,
    createdAt,
    postSlug,
    originalPublishedDate,
    ...rest
}) {
    return {
        publishedDate: originalPublishedDate ?? createdAt,
        excerpt: excerpt.excerpt,
        postLink: `/${postSlug}/`,
        ...rest,
    };
}
